import { gql } from 'graphql-request'

const UPDATE_PUBLISHER_STATUS = gql`
  mutation updatePublisher($id: ID!, $enabled: Boolean!) {
    publisherUpdate(input: { id: $id, attributes: { enabled: $enabled } }) {
      publisher {
        accountManagerId
        createdAt
        enabled
        currency
        id
        name
        updatedAt
      }
      errors
    }
  }
`

export default UPDATE_PUBLISHER_STATUS
